// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Video: MarkdocTagRegistration = {
  tag: 'video',
  component: 'Video',
  attributes: {
    src: {type: String, required: true},
    type: {type: String, default: 'video/mp4'},
    width: {
      type: ['Number', 'String'],
      description: 'Set to the number of pixels for width. Is 100% by default.',
    },
    height: {type: Number},
    controls: {
      type: Boolean,
      default: false,
      description: 'Set to true to display the HTML video controls.',
    },
    muted: {type: Boolean},
  },
};
